import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { ApiResponseModel, ApiVisa, Core2Config} from '../../shared';
import { CmsFormSubmissionContainerModel } from '../../../../../../models/aggregates/cms/form';
import { BaseApiPublicLoginTemplateService } from '../../shared/base-api-public-login-template.service';
import { Observable } from 'rxjs';

@Injectable({providedIn: 'root'})

export class CmsFormSubmissionService extends BaseApiPublicLoginTemplateService<CmsFormSubmissionContainerModel, CmsFormSubmissionContainerModel, CmsFormSubmissionContainerModel> {
    constructor(http: HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'form-submissions';
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'form-submissions';
        this.endpoint_path_public_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'form-submissions/' + BaseApiPublicLoginTemplateService.PUBLIC_EP;
        this.httpClient = http;
      }
    
       postPublic(dtoObject: CmsFormSubmissionContainerModel, visa: ApiVisa): Observable<ApiResponseModel<CmsFormSubmissionContainerModel>> {
        if (this.endpoint_path_public_url && visa.api_domain_url) {
          this.apiUrl = visa.api_domain_url + this.endpoint_path_public_url;
        }
        return this.httpClient.post<ApiResponseModel<CmsFormSubmissionContainerModel>>(
          this.apiUrl,
          dtoObject,
          this.getHttpHeader(visa)
        );
      }
    
}
